import React from 'react'

function Introduction(){
    return <section className="section__introduction">
        <h1>KPOP Visualization</h1>
        <h6>By Arix Phua</h6>
        <p style={{ marginTop : "15px" }}>Best viewed on desktop</p>
    </section>
}

export default Introduction;